import React  from 'react';
import Iframe from 'react-iframe'
import './App.css';
import './Report.css';

class ReportAI extends React.Component {

	renderIFrame() {
		
		var userID = this.props.userID;
		var userID2 = 2*userID + 123;
		var url = "https://dashboardapi.plurato.com/chat/index.html?obf=" + userID2;
		
		return (
			<div className="ReportAITopContainer">
				<Iframe url={url} width="99%" height="100%" frameBorder="0"></Iframe>
			</div>
		);
	}

	render() {
		return this.renderIFrame();
	}
}

export default ReportAI;

